"use client";

import React from "react";
import { Badge } from "../../badge.js";

interface AttendeeAvatarProps {
  name?: string;
  email: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

export function AttendeeAvatar({ 
  name, 
  email, 
  size = "md", 
  className = "" 
}: AttendeeAvatarProps) {
  const sizeClasses = {
    sm: "h-6 w-6 text-xs",
    md: "h-8 w-8 text-sm", 
    lg: "h-10 w-10 text-base"
  };

  const initial = name 
    ? name.charAt(0).toUpperCase() 
    : email.charAt(0).toUpperCase();

  return (
    <div className={`${sizeClasses[size]} bg-slate-100 text-slate-700 rounded-full flex items-center justify-center ring-1 ring-inset ring-gray-200 ${className}`}>
      <span className="font-semibold">
        {initial}
      </span>
    </div>
  );
}
